import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The specialists section: the list and a specialist's page. One guard for both. */
export const Route = createFileRoute("/_app/specialists")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "specialists");
  },
  component: Outlet,
});
